import SuggestSelect from "components/common/input/SuggestSelect";
import { CorpModel } from "models";
import React from "react";

type PROPS = {
  corps: CorpModel[];
  list: CorpModel[];
  onSelect: (corpID: string) => boolean;
  disabled?: boolean;
};

const CorpSelect: React.FC<PROPS> = (props) => {
  const [options, setOptions] = React.useState<
    { label: string; value: string }[]
  >([]);

  React.useEffect(() => {
    const tmp = props.corps.filter((v) => {
      if (props.list.find((listItem) => listItem.corp_id === v.corp_id)) {
        // すでに設定済みの会社は選択肢から除外する
        return false;
      }
      return true;
    });
    setOptions(
      tmp.map((v) => {
        return { label: v.corp_name, value: v.corp_id };
      })
    );
  }, [props.corps, props.list]);

  return (
    <SuggestSelect
      items={options}
      onSelect={props.onSelect}
      disabled={props.disabled}
    />
  );
};
export default CorpSelect;
